angular.module('app').filter('phone', function() {
    return function(input) {
        if(!input) {
            return input;
        }
        var stripped = input.replace(/[^0-9]/g, '');
        if(stripped.length == 10) {
            return '(' + stripped.substr(0, 3) + ') ' + stripped.substr(3, 3) + '-' + stripped.substr(6, 4);
        }

        return input;
    };
});
